import { render, staticRenderFns } from "./addFaceIn.vue?vue&type=template&id=48f61326&scoped=true&"
import script from "./addFaceIn.vue?vue&type=script&lang=js&"
export * from "./addFaceIn.vue?vue&type=script&lang=js&"
import style0 from "./addFaceIn.vue?vue&type=style&index=0&id=48f61326&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f61326",
  null
  
)

export default component.exports